import React from 'react';

import StageDotBadge from 'bundles/apex/deals/stages/dot_badge';
import { CARD_THEMES } from './card_theme';
import { IndexCard, getIndexCards } from './index_card';
import { LinkCard, getCardPaths } from './link_card';

import type { Deal } from 'bundles/apex/deals/types';
import type { DealToolCall } from '../types';

interface DealCardsProps {
  toolCalls: DealToolCall[];
}

export function DealCards({ toolCalls }: DealCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path} theme={CARD_THEMES.deal}>
          {(deal: Deal) => (
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold text-truncate">{deal.displayName}</span>
              <StageDotBadge className="flex-shrink-0" stage={deal.stage} stageLabel={deal.stageLabel} />
            </div>
          )}
        </LinkCard>
      ))}
      {getIndexCards(toolCalls).map(index => (
        <IndexCard index={index} key={index.path} label="deals" pageName="Pipeline" theme={CARD_THEMES.deal} />
      ))}
    </>
  );
}
